export const responseDomainMock = {
    data: [
      {
        dominioId: 19,
        itens: [
          {
            codigo: "551",
            referencia: "000000551",
            valor: "CI OU RG",
            valorSumarizado: "RG",
          },
          {
            codigo: "552",
            referencia: "000000552",
            valor: "CIE OU RNE",
            valorSumarizado: "RNE",
          },
          {
            codigo: "558",
            referencia: "000000558",
            valor: "CNH",
            valorSumarizado: "CNH",
          },
        ],
      },
      {
        dominioId: 29,
        itens: [
          {
            codigo: "1191",
            referencia: "F",
            valor: "FEMININO",
            valorSumarizado: "FEMININO",
          },
          {
            codigo: "1192",
            referencia: "M",
            valor: "MASCULINO",
            valorSumarizado: "MASCULINO",
          },
        ],
      },
      {
        dominioId: 28,
        itens: [
          {
            codigo: "959",
            referencia: "525",
            valor: "ACOUGUEIRO",
            valorSumarizado: "ACOUGUEIRO",
          },
          {
            codigo: "960",
            referencia: "125",
            valor: "ADMINISTRADOR",
            valorSumarizado: "ADMINISTRADOR",
          },
        ],
      },
      {
        dominioId: 13,
        itens: [
          {
            codigo: "176",
            referencia: "000000176",
            valor: "ABEXCON",
            valorSumarizado: "ABEXCON",
          },
          {
            codigo: "177",
            referencia: "000000177",
            valor: "ADGU",
            valorSumarizado: "ADGU",
          },
        ],
      },
      {
        dominioId: 469,
        itens: [
          {
            codigo: "11829",
            referencia: "A",
            valor: "EMPREGADO EMPRESA PRIVADA",
            valorSumarizado: "EMPREGADO EMPRESA PRIVADA",
          },
          {
            codigo: "11830",
            referencia: "B",
            valor: "PROFISSIONAL LIBERAL",
            valorSumarizado: "PROFISSIONAL LIBERAL",
          },
        ],
      },
      {
        dominioId: 24,
        itens: [
          {
            codigo: "619",
            referencia: "AF",
            valor: "AFEGA",
            valorSumarizado: "AFEGA",
          },
          {
            codigo: "620",
            referencia: "AL",
            valor: "ALBANESA",
            valorSumarizado: "ALBANESA",
          },
        ],
      },
      {
        dominioId: 23,
        itens: [
          {
            codigo: "608",
            referencia: "01",
            valor: "CASADO",
            valorSumarizado: "CASADO",
          },
          {
            codigo: "611",
            referencia: "09",
            valor: "DIVORCIADO",
            valorSumarizado: "DIVORCIADO",
          },
          {
            codigo: "612",
            referencia: "07",
            valor: "UNIAO ESTAVEL",
            valorSumarizado: "UNIAO ESTAVEL",
          },
          {
            codigo: "616",
            referencia: "10",
            valor: "SEPARADO",
            valorSumarizado: "SEPARADO",
          },
          {
            codigo: "617",
            referencia: "04",
            valor: "SOLTEIRO",
            valorSumarizado: "SOLTEIRO",
          },
          {
            codigo: "618",
            referencia: "06",
            valor: "VIUVO",
            valorSumarizado: "VIUVO",
          },
        ],
      },
    ],
  };